/**
 * Prevents automatic RTL (right-to-left) flipping of a CSS declaration]
 *
 * By appending the `/* @noflip *\/` comment.
 */
export function noRtlFlip(cssValue: unknown): string {
  if (typeof cssValue !== 'string') {
    console.warn('Invalid CSS value provided');
    return '';
  }

  const trimmed = cssValue.trim();

  if (!trimmed) {
    console.warn('Empty CSS value provided');
    return '';
  }

  if (trimmed.includes('/* @noflip */')) {
    return trimmed;
  }

  return `${trimmed} /* @noflip */`;
}
